















import Vue from "vue";
export default Vue.extend({
  name: "v-icon",
  props: {
    icon: {
      type: String as () => string,
      required: true as boolean,
      default: "close" as string
    },
    width: {
      type: Number as () => number,
      required: false as boolean,
      default: 18 as number
    },
    height: {
      type: Number as () => number,
      required: false as boolean,
      default: 18 as number
    },
    spin: {
      type: Boolean as () => boolean,
      required: false as boolean,
      default: false as boolean
    }
  },
  data: () => {
    return {
      currentComponent: null as null
    };
  },
  watch: {
    icon: function(newVal, oldVal) {
      newVal !== oldVal && this.loadComponent();
    }
  },
  methods: {
    loadComponent(): void {
      import(
        `@/assets/icons/Icon${this.icon
          .charAt(0)
          .toUpperCase()}${this.icon.slice(1)}.vue`
      )
        .then(res => (this.currentComponent = res.default))
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.loadComponent();
  }
});
